import PopupsMobile from '../popups-mobile/popups-mobile';

export default new class CategoryFiters {
    constructor() {
        this.categoryFilters = '[data-category-filters]';

        if (!$(this.categoryFilters).length) return;

        this.categoryFilterTitle = '[data-category-filter-title]';
        this.categoryFiltersItem = '[data-category-filters-item]';
        this.categoryFiltersList = '[data-category-filters-list]';
        this.categoryFiltersListItem = '[data-category-filters-list-item]';
        this.categoryFiltersBtnReset = '[data-category-filters-reset]';

        this.categoryPage = '[data-category]';
        this.categorySortBtn = '[data-category-sort-btn]';
        this.preloader = '[data-preloader]';

        this.classOpen = '_open';
        this.classActive = '_active';
        this.classShow = '_show';

        this.eventsHandler()
    }

    eventsHandler() {
        let $doc = $(document);

        $doc.on('click', this.categoryFilterTitle, (e) => {
            this.toggleList($(e.currentTarget))
        });

        $doc.on('click', this.categoryFiltersListItem, (e) => {
            this.collectFilters($(e.currentTarget));
            this.isMobile() ? PopupsMobile.closePopup(): false;
            $(this.preloader).addClass(this.classShow);
        });

        $doc.on('click', this.categoryFiltersBtnReset, (e) => {
            e.preventDefault();
           this.resetFilters($(e.currentTarget));
        })
    }

    resetFilters($btnReset) {
        let arCheckboxes = $btnReset.closest(this.categoryFilters).find(this.categoryFiltersListItem);
        arCheckboxes.each((i, item) => {
           $(item).prop('checked', false)
        });

        this.collectFilters(arCheckboxes)
    }

    sortType() {
        let sortType;

        $(this.categorySortBtn).each((i, item) => {
            if ($(item).hasClass(this.classActive)) {
                sortType = $(item).data('category-sort-btn')
            }
        });

        return sortType;
    }

    collectFilters($btn) {
        let arFilters = $btn.closest(this.categoryFilters).find(this.categoryFiltersItem),
            filtersData = {},
            categoryID = $(this.categoryPage).data('category-id');

        arFilters.map((i,item) => {
            filtersData[$(item).data('category-filters-item')] = this.collectSelectedCheckbox($(item))
        });

        let data = {
            filters: filtersData,
            sort: this.sortType(),
            page: 1,
            category_id: categoryID
        };

        this.sendData(data)
    }

    collectSelectedCheckbox($item) {
        let arr = [];

        $item.find(this.categoryFiltersListItem).map((i,item) => {
            if ($(item).prop('checked') === true) {
                arr.push($(item).attr('name'))
            }
        });

        return arr;
    }

    collectFilterData(arCheckboxes, action) {
        let filterData = {};

        arCheckboxes.each((i, item) => {
            filterData[$(item).attr('name')] = action !== 'reset' ? $(item).prop('checked'): false;
        });

        this.sendData(filterData)
    }

    sendData(data) {
        let CategoryFilters = this;

        $.request('onUpdate', {
            update: {'category/products-list':'.category__list-wrap'},
            data: {'data':data},
            complete:function(response){
                $(CategoryFilters.preloader).removeClass(CategoryFilters.classShow);
            }
        })
    }

    toggleList($title) {
        let $categoryItem = $title.closest(this.categoryFiltersItem);

        $categoryItem.find(this.categoryFiltersList).slideToggle();
        $categoryItem.toggleClass(this.classOpen);
    }

    isMobile(){
        return $(window).width() < 768
    }
}
